module.exports = __webpack_public_path__ + "static/media/news-boomer.e748b67f.svg";